<template>
	<CharacteristicSelectInline
		:value="value"
		:characteristic-items="meta.overtime"
		initial-show-all
		:nothing-allowed="{
			text: 'Nein'
		}"
		suppress-items-info
		:label-type="labelTypeJobProfile"
		:post-selection-function="postSelectionFunction"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline";
import {ALL_INCLUSIVE} from "@/helper/job-profile/Overtime";
import {JOB_PROFILE} from "@/helper/characteristic/Label";

export default {

	components: {
		CharacteristicSelectInline,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},

	computed: {
		labelTypeJobProfile ()
		{
			return JOB_PROFILE;
		}
	},

	methods: {
		postSelectionFunction ({selected, newlySelectedCharacteristic})
		{
			if (selected && selected.length === 0)
			{
				return selected;
			}

			if (newlySelectedCharacteristic && newlySelectedCharacteristic.naturalId === ALL_INCLUSIVE)
			{
				selected = _.filter(selected, item => item.item.naturalId === ALL_INCLUSIVE);
			}
			else
			{
				selected = _.filter(selected, item => item.item.naturalId !== ALL_INCLUSIVE);
			}

			return selected;
		},
	},
}
</script>
